import styled from 'styled-components';

const Option = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export default Option;
